export function deleteContract(data) {
    let { deleteContractRequest, deleteContractError, deleteContractResult } = this.props

    this.doAction(
        this.WEB_REQUEST_URL + 'delete_contract',
        this.createBundle('delete_contract', { contract: data }, this.GET, deleteContractRequest, deleteContractResult, deleteContractError)
    )
}
